import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PixelDimensions2D } from '../../../../../features/lockers/models/pixel-dimensions-2d.model';
import { PixelPosition2D } from '../../../../../features/lockers/models/pixel-position-2d.model';

export type DeliveryContainerTileStyleProps = {
  pixelDimensions2D: PixelDimensions2D;
  pixelPosition2D: PixelPosition2D;
  backgroundColor?: string;
  isHighlighted?: boolean;
  highlightColor?: string;
  disablePointer?: boolean;
};

export const useDeliveryContainerTileStyles = makeStyles<Theme, DeliveryContainerTileStyleProps>({
  root: {
    position: 'absolute',
    left: ({ pixelPosition2D }) => pixelPosition2D.x,
    bottom: ({ pixelPosition2D }) => pixelPosition2D.y,
    width: ({ pixelDimensions2D, pixelPosition2D }) =>
      // If the tile is positioned on the left of the tower, subtract 1px to avoid overflow
      pixelPosition2D.xNumber === 0 ? subtractPixelValues(pixelDimensions2D.width, 1) : pixelDimensions2D.width,
    height: ({ pixelDimensions2D }) => pixelDimensions2D.height,
    backgroundColor: ({ backgroundColor }) => backgroundColor || '#FFFFFF',
    padding({ pixelDimensions2D }) {
      let verticalPadding = 16;
      let horizontalPadding = 16;
      if (pixelDimensions2D.widthNumber <= 75) {
        horizontalPadding = 0;
      }
      if (pixelDimensions2D.heightNumber < 50) {
        verticalPadding = 6;
      }
      return `${verticalPadding}px ${horizontalPadding}px`;
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    '&:hover': {
      cursor: ({ disablePointer }) => (disablePointer ? 'default' : 'pointer')
    },
    outline: ({ isHighlighted, highlightColor }) =>
      `1px solid ${isHighlighted && highlightColor ? highlightColor : 'lightgrey'}`,
    boxShadow: ({ isHighlighted, highlightColor }) =>
      isHighlighted && highlightColor ? `inset 0 0 12px 2px ${highlightColor}` : 'none'
  },
  tooltip: {
    backgroundColor: 'transparent',
    padding: 0,
    margin: 0
  }
});

function subtractPixelValues(pixelValue: string, subtractValue: number): string {
  const numericValue = parseFloat(pixelValue.replace('px', ''));
  return `${numericValue - subtractValue}px`;
}
